import { createSlice } from "@reduxjs/toolkit";

export const agentChatSlice = createSlice({
  name: "agentChat",
  initialState: {
    sessions: [],
    activeSessionId: null,
    messages: [],
    isLoadingMessages: false,
    isSendingMessage: false,
  },
  reducers: {
    getSessionsRequest: () => {},
    getSessionsResponse: (state, action) => {
      state.sessions = action.payload;
    },
    getSessionDetailsRequest: (state, action) => {
      state.activeSessionId = action.payload;
      state.isLoadingMessages = true;
      state.messages = [];
    },
    getSessionDetailsResponse: (state, action) => {
      state.messages = action.payload;
      state.isLoadingMessages = false;
    },
    sendMessageRequest: (state, action) => {
      state.messages = [
        ...state.messages,
        {
          role: "user",
          content: action.payload.message,
          timestamp: new Date().toISOString(),
        },
      ];
      state.isSendingMessage = true;
    },
    sendMessageResponse: (state, action) => {
      state.activeSessionId = action.payload.sessionId;
      state.messages = [
        ...state.messages,
        {
          role: "agent",
          content: action.payload.reply,
          timestamp: action.payload.timestamp,
        },
      ];
      state.isSendingMessage = false;
    },
    updateSessionInList: (state, action) => {
      const { id, title, lastMessage, updatedAt, replaceId } = action.payload;
      // If replaceId is provided (e.g. "__pending__"), swap the placeholder out
      const replaceIndex = replaceId != null
        ? state.sessions.findIndex((s) => s.id === replaceId)
        : -1;
      if (replaceIndex >= 0) {
        state.sessions[replaceIndex] = { id, title, lastMessage, updatedAt };
        return;
      }
      const existingIndex = state.sessions.findIndex((s) => s.id === id);
      if (existingIndex >= 0) {
        state.sessions[existingIndex] = {
          ...state.sessions[existingIndex],
          lastMessage,
          updatedAt,
        };
      } else {
        state.sessions = [{ id, title, lastMessage, updatedAt }, ...state.sessions];
      }
    },
    removeSessionFromList: (state, action) => {
      state.sessions = state.sessions.filter((s) => s.id !== action.payload);
    },
    setActiveSessionId: (state, action) => {
      state.activeSessionId = action.payload;
    },
    setSendingMessageFailed: (state) => {
      state.isSendingMessage = false;
    },
    stopAgentRequest: () => {},
    startNewSession: (state) => {
      state.activeSessionId = null;
      state.messages = [];
      state.isLoadingMessages = false;
    },
  },
});

export const {
  getSessionsRequest,
  getSessionsResponse,
  getSessionDetailsRequest,
  getSessionDetailsResponse,
  sendMessageRequest,
  sendMessageResponse,
  updateSessionInList,
  removeSessionFromList,
  setActiveSessionId,
  setSendingMessageFailed,
  stopAgentRequest,
  startNewSession,
} = agentChatSlice.actions;

export default agentChatSlice.reducer;
